export const CIC_EXPECTATIONS = {
    met: {
        en: 'Completely met',
        es: 'Totalmente cumplidas'
    },
    most_met: {
        en: 'Mostly met',
        es: 'En su mayoría cumplidas'
    },
    most_not: {
        en: 'Mostly not met',
        es: 'En su mayoría no se cumplieron'
    },
    not: {
        en: 'Not at all met',
        es: 'Para nada cumplidas'
    },
    idk: {
        en: "Don't know",
        es: 'No sé'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
